<template>
    <div v-if="bottomBar" class="mob-top-bar">
      <router-link to="/pikles" class="home-logo-mob">
        <img
          alt="Pikle Logo"
          :src="require('../../assets/logo-full.svg')"
          width="76"
        />
      </router-link>
      <UserMenu absolute />
      <div class="mt-3">
        <InvitesMenu />
      </div>
      <!-- <AppBottomBar :navList="nav" /> -->
    </div>
    <!-- <v-toolbar v-else light dense :elevation="1" :absolute="absolute"> -->
    <div v-else>
      <v-progress-linear v-if="navigatingToDecision" height="2" style="z-index: 2000;" indeterminate color="primary"></v-progress-linear>
      <!-- <v-app-bar density="compact" app color="white" scroll-behavior="elevate"> -->
      <v-app-bar density="compact" app color="white" elevation="0" class="defaul-app-bar">
        <v-container fluid class="pa-0 fill-height">
          <router-link to="/pikles" class="d-flex align-center">
            <img
              alt="Pikle Logo"
              :src="require('../../assets/logo-full.svg')"
              width="76"
              class="logo-img navigating"
            />
          </router-link>
          <div v-if="currentTaxon" class="taxon-title">{{currentTaxon.name}}</div>
          <v-toolbar-items v-if="showNav" class="app-bar-nav-items mr-6">
            <v-btn
              class="app-bar-button"
              v-for="item in nav"
              :key="item.icon"
              :to="item.requiresRegion ? regionalPath(item.path) : item.path"
              selected-class="active-section"
              :active="$route.path === (item.requiresRegion ? regionalPath(item.path) : item.path)"
              text
            >
              <v-icon small class="mr-1">{{ item.icon }}</v-icon> {{ $t(`${item.i18n}`) }}
            </v-btn>
          </v-toolbar-items>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-list-item class="px-0">
              <InvitesMenu />
            </v-list-item>
            <v-list-item class="px-0">
              <UserMenu separateRegionMenu />
            </v-list-item>
          </v-toolbar-items>
      </v-container>
    </v-app-bar>
  </div>
</template>

<script>

import UserMenu from './UserMenu'
// import AppBottomBar from './AppBottomBar'

import taxonomyAPI from '../../api/taxonomy'

import InvitesMenu from '@/components/Navigation/InvitesMenu'

import { mapState } from 'vuex'

export default {
  name: 'AppToolbar',
  props: {
    showNav: {
      type: Boolean,
      default: true
    },
    absolute: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      // nav: [
      //   {
      //     icon: 'mdi-magnify',
      //     i18n: 'navigation.app.discover',
      //     path: '/discover',
      //     requiresRegion: true
      //   },
      //   {
      //     icon: 'mdi-star-outline',
      //     i18n: 'navigation.app.decisions',
      //     path: '/pikles'
      //   }
      // ],
      currentTaxon: null
    }
  },
  computed: {
    ...mapState({
      navigatingToDecision: state => state.pikleBoard.navigating,
      currentCountry: state => state.user.currentCountry,
      currentTaxonRegion: state => state.user.currentTaxonRegion
    }),
    bottomBar () {
      let res = false
      switch (this.$vuetify.display.name) {
        case 'xs': res = true; break;
        case 'sm': res = true; break;
      }
      return res
    },
    nav () {
      const res = [
        {
          icon: 'mdi-bulletin-board',
          i18n: 'navigation.app.decisions',
          path: '/decisions'
        },
        {
          icon: 'mdi-label-multiple',
          i18n: 'navigation.app.labels',
          path: '/labels'
        }
      ]

      // if (this.currentCountry === 'NZ') {
      //   res.unshift({
      //     icon: 'mdi-magnify',
      //     i18n: 'navigation.app.discover',
      //     path: '/discover',
      //     requiresRegion: true
      //   })
      // }
      return res
    }
  },
  components: {
    UserMenu,
    // AppBottomBar,
    InvitesMenu
  },
  watch: {
    $route () {
      this.currentTaxon = null
    },
    // Whenver the decision id changes this will run and load appropriate data
    currentTaxonRegion: async function (newVal) {
      if (newVal) {
        this.getCurrentTaxon()
      }
    },
    prefsLoaded: function (newVal) {
      if (newVal && !this.inited) {
        this.initUserData()
      }
    }
  },
  async mounted() {
    this.getCurrentTaxon()
  },
  methods: {
    regionalPath: function (basePath) {
      if (this.currentCountry) {
        return `/${this.currentCountry.toLowerCase()}${basePath}`
      } else {
        return basePath
      }
    },
    getCurrentTaxon: async function () {
      const currentTaxonParam = this.$route.params.taxonId
      if (currentTaxonParam) {
        const categoryResponse = await taxonomyAPI.getCategoryData(currentTaxonParam, this.currentTaxonRegion)
        if (categoryResponse && categoryResponse.status === 'success' && categoryResponse.category) {
          this.currentTaxon = categoryResponse.category
        }
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.logo-img {

  // margin-top: 3px;
  margin-left: 60px;

  &.navigating {
    margin-left: 17px;
  }
}

.defaul-app-bar {
  border-bottom: 1px solid #CCC;
}

.mob-top-bar {
  // position: fixed;
  // top: 0;
  width: 100%;
  height: 48px;
  background-color: #FFF;
  z-index: 200;
  // margin-top: 3px;
  border-bottom: 1px solid #CCC;

  .home-logo-mob {
    position: absolute;
    top: 3px;
    left: 17px;
  }
}

.app-bar-nav-items {
  margin-left: 185px;
}

.app-bar-button {
  text-transform: capitalize;
  margin-top: 0px;
  padding: 10px 20px !important;
  color: #222;
  font-weight: 400;
  font-size: 0.8rem;

  &.v-btn--active {
    color: #005aff;
    // background-color: #FFF;
    // border-bottom: 1px solid #005aff;
    // opacity: 1 !important;

    .v-icon {
      color: #005aff;
    }
  }
}

.taxon-title {
  font-size: 1.8rem;
  margin-top: 5px;
  margin-left: 20px;
  color: #5b4c4c;
}
</style>

<style lang="scss">
.app-bar-button.v-btn--active {
  & .v-btn__overlay {
    background-color: #FFF;
  }
}
</style>
